import { combineReducers } from 'redux';
import edit from './modules/edit/reducer';
import listPage from './modules/listing/reducer';

export default combineReducers({
  edit,
  listPage,
});
